import Intents, { enums } from '@ux/intents';

export default (function () {
  const intents = new Intents();

  intents.create('@ux/tray-menu', {
    styleProperties: [
      enums.properties.BACKGROUND_COLOR,
      enums.properties.FONT_SIZE
    ],
    interactions: [
      enums.interactions.CHOSEN
    ],
    features: {
      // Menu button
      [enums.features.INDICATOR]: {
        styleProperties: [
          enums.properties.FONT_SIZE,
          enums.properties.FONT_WEIGHT,
          enums.properties.BORDER_RADIUS
        ]
      }
    }
  });

  // Menu container default
  intents.uxTrayMenu.backgroundColor = 'transparent';
  intents.uxTrayMenu.fontSize = intents.ux.text.fontSize;

  // Menu contrainer open
  intents.uxTrayMenuChosen.backgroundColor = intents.ux.boxLowContrast.backgroundColor;

  // Menu button
  intents.uxTrayMenu.indicator.fontSize = intents.ux.textAction.fontSize;
  intents.uxTrayMenu.indicator.fontWeight = intents.ux.textAction.fontWeight;
  intents.uxTrayMenu.indicator.borderRadius = intents.ux.action.borderRadius;

  return intents;
}());
